import React from "react";
import { useField, useFormikContext } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function DatePickerField({ ...props }) {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);
  return (
    <DatePicker
      {...field}
      {...props}
      selected={(field.value && new Date(field.value)) || null}
      onChange={val => {
        // @see https://github.com/Hacker0x01/react-datepicker/issues/1018
        const offsetDate = new Date(val.getTime() - (val.getTimezoneOffset() * 60000));
        setFieldValue(field.name, offsetDate);
      }}
    />
  );
};